module.exports = "../dist/img/product-detail-4-21.d79a.jpg";